interface IconProps {
  color?: string;
  size?: string | number;
}

const ChevronUpCircleIcon = ({ color = "currentColor", size = 24 }: IconProps) => {
  return (
    <svg height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_11_445)">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
        <path
          d="M15.857 13.035L12.445 9.061C12.3899 8.99694 12.3216 8.94553 12.2448 8.91029C12.168 8.87505 12.0845 8.85681 12 8.85681C11.9155 8.85681 11.832 8.87505 11.7552 8.91029C11.6784 8.94553 11.6101 8.99694 11.555 9.061L8.14201 13.035C8.06938 13.12 8.02263 13.2241 8.0073 13.3348C7.99198 13.4456 8.00872 13.5584 8.05555 13.66C8.10237 13.7615 8.17732 13.8475 8.27151 13.9078C8.3657 13.968 8.47519 14 8.58701 14L15.413 14C15.5249 14.0003 15.6346 13.9684 15.7289 13.9081C15.8232 13.8479 15.8982 13.7618 15.945 13.6601C15.9917 13.5584 16.0083 13.4455 15.9927 13.3346C15.9771 13.2238 15.93 13.1198 15.857 13.035Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11_445">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChevronUpCircleIcon;
